const NavigationBanner = ({ title, background }) => {
  return (
    <div className="relative w-full h-32 sm:h-48 md:h-52 overflow-hidden">
      {/* Background Image with subtle scale animation */}
      <img
        src={background}
        alt={`banner-image`}
        className="absolute inset-0 w-full h-full object-cover object-center transform transition-transform duration-700 ease-out hover:scale-105"
        data-aos="fade-down"
        data-aos-duration="1200"
      />

      {/* Gradient Overlay */}
      <div
        className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/40 to-black/60"
        data-aos="fade-down"
        data-aos-duration="1000"
      ></div>

      {/* Title */}
      <div
        className="relative z-10 flex items-center  h-full px-4 lg:px-12"
        data-aos="fade-down"
        data-aos-duration="1200"
        data-aos-easing="ease-out"
      >
        <h1 className="text-white text-xl sm:text-2xl md:text-3xl font-bold text-left  tracking-wide ">
          {title}
        </h1>
      </div>
    </div>
  );
};

export default NavigationBanner;
